import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=f2b40c8c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b40c8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2b40c8c')) {
      api.createRecord('f2b40c8c', component.options)
    } else {
      api.reload('f2b40c8c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=f2b40c8c&scoped=true&", function () {
      api.rerender('f2b40c8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2n937v0qYSzQl/JS/comp/SearchFilterTokens.vue"
export default component.exports